import { render, staticRenderFns } from "./DeviceSimple.vue?vue&type=template&id=22b2889f&scoped=true&"
import script from "./DeviceSimple.vue?vue&type=script&lang=js&"
export * from "./DeviceSimple.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSimple.vue?vue&type=style&index=0&id=22b2889f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b2889f",
  null
  
)

export default component.exports